import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import useI18n from "@/i18n";

const Bloc = ({ titre, lignes, testid }) => (
    <div data-testid={testid}>
        <h3 className="eyebrow">{titre}</h3>
        <ul className="mt-3">
            {lignes.map(([annee, intitule, etab]) => (
                <li
                    key={`${annee}-${intitule}`}
                    className="flex gap-4 border-b py-3 last:border-0"
                    style={{ borderColor: "var(--c-line)" }}
                >
                    <span className="w-12 shrink-0 font-display text-lg text-terrat">{annee}</span>
                    <span>
                        <span className="block font-semibold">{intitule}</span>
                        <span className="block text-sm text-ink2">{etab}</span>
                    </span>
                </li>
            ))}
        </ul>
    </div>
);

export default function FormationDialog({ trigger }) {
    const { t } = useI18n();
    return (
        <Dialog.Root>
            <Dialog.Trigger asChild>{trigger}</Dialog.Trigger>
            <Dialog.Portal>
                <Dialog.Overlay
                    className="fixed inset-0 z-50 data-[state=open]:animate-in data-[state=open]:fade-in-0"
                    style={{
                        background: "rgba(59, 42, 34, 0.55)",
                        backdropFilter: "blur(6px)",
                        WebkitBackdropFilter: "blur(6px)",
                    }}
                />
                <Dialog.Content
                    data-testid="formation-dialog"
                    className="fixed left-1/2 top-1/2 z-50 max-h-[85vh] w-[calc(100vw-2rem)] max-w-[600px] -translate-x-1/2 -translate-y-1/2 overflow-y-auto rounded-[22px] p-7 shadow-[0_40px_90px_-40px_rgba(59,42,34,0.6)] data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 md:p-9"
                    style={{
                        background: "linear-gradient(180deg, var(--blanc-pur) 0%, var(--rose-clair) 100%)",
                        border: "1px solid var(--c-line)",
                    }}
                >
                    <Dialog.Close
                        className="absolute right-5 top-5 rounded-full p-2 text-ink2 transition-colors duration-200 hover:bg-white hover:text-terrat"
                        data-testid="formation-dialog-close"
                        aria-label={t.formation.closeLabel}
                    >
                        <X size={18} />
                    </Dialog.Close>
                    <Dialog.Title className="pr-10 text-2xl text-terrat md:text-3xl">
                        {t.formation.dialogTitle}
                    </Dialog.Title>
                    <hr className="rule-gold mt-3 w-16" />
                    <Dialog.Description className="mt-4 text-sm text-ink2">
                        {t.formation.subtitle}
                    </Dialog.Description>
                    <div className="mt-7 space-y-7">
                        <Bloc
                            titre={t.formation.diplomesTitle}
                            lignes={t.formation.diplomes}
                            testid="formation-diplomes"
                        />
                        <Bloc
                            titre={t.formation.autresTitle}
                            lignes={t.formation.autres}
                            testid="formation-autres"
                        />
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
}
